export const HomePageSection1 = [
    {
        url:"https://images.pexels.com/photos/6442024/pexels-photo-6442024.jpeg",
        text:"Explore the waterfall deep inside Amazon Jungle",
        label:'Adventure',
        path:'/waterfall'
    },
    {
        url:"https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
        text:"Travel through the Islands of Bali in a private Cruise",
        label:'Adventure',
        path:'/beach'
    },
    {
        url:"https://images.pexels.com/photos/1374064/pexels-photo-1374064.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        text:"Explore the Mountains",
        label:'Adventure',
        path:'/mountains'
    }
]


